import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  useTheme,
  useMediaQuery,
  Breadcrumbs,
  Link as MUILink,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Chip,
  IconButton,
  Card,
  CardContent,
  Grid,
  Stack,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link } from "react-router-dom";
import { Modal, message as AntMessage } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getAllSupportTickets,
  deleteSupportTicket,
} from "../redux/slices/supportSlice";


// Static support tickets data
// const staticTickets = [
//   {
//     _id: "1",
//     ticketId: "TICKET-001",
//     subject: "Issue with Order #ORD-2024-001",
//     description: "Payment received but order status not updated",
//     status: "Open",
//     createdBy: "Rajesh Kumar",
//     createdAt: "2024-02-01",
//   },
//   {
//     _id: "2",
//     ticketId: "TICKET-002",
//     subject: "Invoice not generated",
//     description: "Invoice for order #ORD-2024-005 is missing",
//     status: "In Progress",
//     createdBy: "Priya Sharma",
//     createdAt: "2024-02-02",
//   },
//   {
//     _id: "3",
//     ticketId: "TICKET-003",
//     subject: "Account access issue",
//     description: "Unable to login to buyer dashboard",
//     status: "Resolved",
//     createdBy: "Amit Patel",
//     createdAt: "2024-02-03",
//   },
//   {
//     _id: "4",
//     ticketId: "TICKET-004",
//     subject: "Shipping delay inquiry",
//     description: "Order placed 10 days ago but not shipped yet",
//     status: "Open",
//     createdBy: "Sneha Desai",
//     createdAt: "2024-02-04",
//   },
//   {
//     _id: "5",
//     ticketId: "TICKET-005",
//     subject: "Payment gateway error",
//     description: "Transaction failed but amount deducted",
//     status: "In Progress",
//     createdBy: "Vikram Singh",
//     createdAt: "2024-02-05",
//   },
//   {
//     _id: "6",
//     ticketId: "TICKET-006",
//     subject: "Product quality complaint",
//     description: "Received damaged items in Order #ORD-2024-008",
//     status: "Open",
//     createdBy: "Meera Joshi",
//     createdAt: "2024-02-06",
//   },
// ];

export default function AdminSupport() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const [tickets, setTickets] = useState(staticTickets);
const dispatch = useDispatch();
const { tickets, loading } = useSelector((state) => state.support);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  useEffect(() => {
  dispatch(getAllSupportTickets());
}, [dispatch]);

const handleDelete = (id) => {
  Modal.confirm({
    title: "Are you sure you want to delete this ticket?",
    okText: "Yes, Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk: async () => {
      await dispatch(deleteSupportTicket(id));
      await dispatch(getAllSupportTickets())
      AntMessage.success("Ticket deleted successfully");
    },
  });
};

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: "#f8fafc",
        py: { xs: 1, sm: 2 },
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          width: "fit-content",
          backgroundColor: "#fff",
          ml: { xs: 1, sm: 2.9 },
          padding: "13px",
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/admin-dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "#0b4064", fontWeight: "bold" }}>
          Help & Support
        </Typography>
      </Breadcrumbs>

      <Divider sx={{ my: 2 }} />
      <Box sx={{ maxWidth: 1350, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Typography fontWeight={700} fontSize={22} sx={{ mb: 3 }}>
          Help & Support Center
        </Typography>

        {/* Support Tickets List */}
        <Paper
          elevation={0}
          sx={{
            mt: 4,
            p: { xs: 2, sm: 3 },
            borderRadius: 3,
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            All Support Tickets
          </Typography>

          {/* Table for Desktop */}
          {!isMobile ? (
            <TableContainer>
              <Table>
                <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableRow>
                    <TableCell>
                      <strong>#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Ticket User</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Subject</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Created By</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Actions</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tickets?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((ticket, index) => (
                    <TableRow key={ticket._id}>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                       <Typography sx={{ fontSize: 14, fontWeight: 500 }}> {ticket.user?.name}</Typography>
                       <Typography sx={{ fontSize: 14, fontWeight: 500 }}> {ticket.user?.phone}</Typography>
                        </TableCell>
                      <TableCell>
                        <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                          {ticket.subject}
                        </Typography>
                        <Typography
                          sx={{ fontSize: 12, color: "#777", mt: 0.5 }}
                        >
                          {ticket.description.length > 50
                            ? `${ticket.description.substring(0, 50)}...`
                            : ticket.description}
                        </Typography>
                      </TableCell>
                      <TableCell>{ticket.createdAt}</TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <IconButton
                            onClick={() => handleDelete(ticket._id)}
                            size="small"
                          >
                            <DeleteIcon color="error" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                  {tickets?.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        No support tickets found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={tickets?.length || 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
            </TableContainer>
          ) : (
            // Card View for Mobile
            <Stack spacing={2}>
              {tickets?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((ticket, index) => (<Card
                key={ticket._id}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <CardContent sx={{ p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontSize: 12, color: "#7a7a7a", mb: 0.5 }}
                      >
                        Ticket User
                      </Typography>
                      <Typography fontWeight={600}>
                        {ticket?.user?.name}
                      </Typography>

                       <Typography fontWeight={600}>
                        {ticket?.user?.phone}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontSize: 12, color: "#7a7a7a", mb: 0.5 }}
                      >
                        Subject
                      </Typography>
                      <Typography fontWeight={500}>
                        {ticket.subject}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{ fontSize: 12, color: "#7a7a7a", mb: 0.5 }}
                      >
                        Description
                      </Typography>
                      <Typography sx={{ fontSize: 14 }}>
                        {ticket.description}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        sx={{ fontSize: 12, color: "#7a7a7a", mb: 0.5 }}
                      >
                        Created At
                      </Typography>
                      <Typography>{ticket.createdAt}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
                        <IconButton
                          onClick={() => handleDelete(ticket._id)}
                          size="small"
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              ))}
              <TablePagination
                component="div"
                count={tickets?.length || 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}

              />
            </Stack>

          )}
        </Paper>
      </Box>
    </Box>
  );
}